import { render, staticRenderFns } from "./CreditSoldVersion.vue?vue&type=template&id=15484dfe&scoped=true"
import script from "./CreditSoldVersion.vue?vue&type=script&lang=js"
export * from "./CreditSoldVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15484dfe",
  null
  
)

export default component.exports